import React from 'react';
import propTypes from 'prop-types';
import StatusLegendDot from './StatusLegendDot';

// dot colors match the chip accent bars in CarrierDetailStates (-400 tones)
const LEGEND_ITEMS = [
  { status: 'Added', dotClassName: 'bg-green-400' },
  { status: 'Updated', dotClassName: 'bg-amber-400' },
  { status: 'Removed', dotClassName: 'bg-red-400' }
];

/**
 * left-aligned heading for the oep-tinted state grid: title + total count on
 * one line, and an inline legend with per-status counts underneath.
 * @param title - heading text
 * @param states - 2-letter state codes rendered in the grid
 * @param stateStatusMap - record of `stateCode -> status` used for the counts
 */
export default function StatusGridHeader({ title, states, stateStatusMap }) {
  const counts = states.reduce((acc, code) => {
    const status = stateStatusMap[code];
    if (status) acc[status] = (acc[status] || 0) + 1;
    return acc;
  }, {});

  return (
    <div className='mb-3 flex flex-col gap-1.5'>
      <div className='flex items-baseline gap-2'>
        <h3 className='m-0 text-lg font-semibold text-black'>{title}</h3>
        <span className='text-sm text-gray-500'>{states.length} states</span>
      </div>
      <div className='flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-gray-600'>
        {LEGEND_ITEMS.map(({ status, dotClassName }) => (
          <StatusLegendDot
            key={status}
            className={dotClassName}
            label={status}
            count={counts[status] || 0}
          />
        ))}
      </div>
    </div>
  );
}

StatusGridHeader.propTypes = {
  title: propTypes.string.isRequired,
  states: propTypes.arrayOf(propTypes.string).isRequired,
  stateStatusMap: propTypes.object.isRequired
};
